export const CATALOG_URL = '/catalog'
export const USER_SEARCH_URL = '/member/general/search'
